import { ColorX } from "IZOX/STATIC";

/**
 * @typedef {Object} policyStatus
 * @property {import("IZOX/__typedef/common").lang} label
 * @property {String} color
 * @property {String} bgColor
 */

class PolicyUtils {

  /**
   * @type {Object<string, policyStatus>}
   */
  static __status = {
    Active: {
      label: {
        EN: "Active",
        TC: "生效中"
      },
      color: ColorX.CSS("Active"),
      bgColor: ColorX.CSS("ActiveBg")
    },
    Pending: {
      label: {
        EN: "Pending",
        TC: "處理中"
      },
      color: ColorX.CSS("Pending"),
      bgColor: ColorX.CSS("PendingBg")
    },
    AwaitingClientConfirmation: {
      label: {
        EN: "Awaiting Client",
        TC: "等待客戶確認"
      },
      color: ColorX.CSS("ExpireSoon"),
      bgColor: ColorX.CSS("ExpireSoonBg")
    },
    Expired: {
      label: {
        EN: "Expired",
        TC: "已過期"
      },
      color: ColorX.CSS("Expired"),
      bgColor: ColorX.CSS("ExpiredBg")
    },
    ExpirySoon: {
      label: {
        EN: "Expiry Soon",
        TC: "即將過期"
      },
      color: ColorX.CSS("ExpireSoon"),
      bgColor: ColorX.CSS("ExpireSoonBg")
    },
    Renewed: {
      label: {
        EN: "Renewed",
        TC: "已更新"
      },
      color: ColorX.CSS("Renewed"),
      bgColor: ColorX.CSS("RenewedBg")
    },
    Canceled: {
      label: {
        EN: "Canceled",
        TC: "已取消"
      },
      color: ColorX.CSS("Canceled"),
      bgColor: ColorX.CSS("CanceledBg")
    },
    Edited: {
      label: {
        EN: "Edited",
        TC: "已編輯"
      },
      color: ColorX.CSS("Canceled"),
      bgColor: ColorX.CSS("CanceledBg")
    }
  };

  /**
   * 
   * @param {status} status 
   * @returns {policyStatus}
   */
  static GetStatus(status){
    return this.__status[status] ?? null;
  }

}

export default PolicyUtils;